export const inputType = {
  type: 'file' as const,
  extension: 'ipynb',
};
